import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumForm } from "../typings";

function useFindAreaComum(tenantId: string | null, id?: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${id}`,
    async () => {
      const { data } = await axios.get<AreaComumForm>(
        `/v1/tenants/${tenantId}/area-comum/${id}`
      );

      return data;
    },
    {
      enabled: !!id && !!tenantId,
    }
  );
}

export default useFindAreaComum;
